// extracted by mini-css-extract-plugin
export default {"container":"Sy3NQM","containerOlsVets":"sT0QV4","containerOlsHealth":"XmOiYk","iconItem":"u2ORAa","icon":"yf8_64","iconText":"MYIf3X"};